// extracted by mini-css-extract-plugin
export var arrow = "_ca-2";
export var label = "_ca-1";
export var reminder = "_ca-0";